// src/layouts/ContentBlockWithImage/ContentBlockWithImage.js

import React from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import scrollTo from "gatsby-plugin-smoothscroll"

const ContentBlockWithImage = ({
  landingPageImageContent,
  contentWithImage,
  contentWithImageWidth,
  imageAddCalendlyLink,
}) => {
  return (
    <BlockContent className={contentWithImageWidth}>
      <div dangerouslySetInnerHTML={{ __html: landingPageImageContent }} />
      <GatsbyImage
        image={contentWithImage.localFile.childImageSharp.gatsbyImageData}
        alt={contentWithImage.title}
      />

      {imageAddCalendlyLink ? (
        <div className={"button-cta center-link"}>
          <button onClick={() => scrollTo("#calendly")}>
            Talk to our Experts
          </button>
        </div>
      ) : (
        ""
      )}
    </BlockContent>
  )
}

const BlockContent = styled.section`
  max-width: 1210px;
  width: 100%;
  margin: 50px auto;
  padding: 0 20px;
  &.narrow {
    max-width: 810px;
  }
  h1 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 60px;
    color: #2b2520;
    margin-top: 20px;
  }
  h2 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 40px;
    color: #2b2520;
    margin-top: 20px;
  }
  h3 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 40px;
    line-height: 44px;
    color: #2b2520;
    margin-top: 0;
    margin-bottom: 15px;
  }
  h4 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 32px;
    line-height: 36px;
    color: #2b2520;
    margin-top: 0;
    margin-bottom: 15px;
  }
  h5 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-size: 20px;
    letter-spacing: 2px;
    color: #c44c4a;
    text-transform: uppercase;
    padding-top: 70px;
    margin-top: 0px;
    margin-bottom: 10px;
  }
  p.large {
    font-size: 32px;
    margin-bottom: 35px;
  }
  p.cost {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-size: 32px;
    line-height: 44px;
    color: #2b2520;
  }
  hr {
    height: 5px;
    width: 100%;
    background-color: #ebebeb;
    margin-top: 70px;
  }
  p,
  ul,
  ol {
    font-family: "Work Sans";
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    color: #777c7c;
    margin-bottom: 30px;
    li {
      margin-bottom: 5px;
    }
  }
  ul,
  ol {
    margin-left: 20px;
  }
  .button-cta {
    &.center-link {
      text-align: center;
    }
    button {
      background-color: #c44c4a;
      color: #fff;
      font-family: "Work Sans";
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 1.6px;
      text-transform: uppercase;
      border: none;
      padding: 12px 35px;
      margin-top: 40px;
      &:hover {
        cursor: pointer;
      }
    }
  }
  @media (max-width: 1000px) {
    max-width: 700px;
    padding: 20px 50px;
    flex-wrap: wrap;
    h1,
    h2 {
      font-size: 44px;
      line-height: 1.3;
      margin-bottom: 10px;
      padding-left: 0;
    }
    h3 {
      font-size: 36px;
      line-height: 1.3;
      margin-bottom: 10px;
    }
    h4 {
      font-size: 28px;
      line-height: 1.3;
      margin-bottom: 10px;
    }
    p,
    ul {
      padding-left: 0;
    }
  }
  @media (max-width: 767px) {
    max-width: 500px;
    margin: 20px auto;
    h1 {
      font-size: 36px;
      margin-top: 70px;
    }
    h2 {
      font-size: 36px;
    }
    h3 {
      font-size: 28px;
    }
    h4 {
      font-size: 20px;
    }
    ul {
      margin-left: 0;
    }
    p,
    ul {
      font-size: 16px;
      line-height: 1.6;
    }
  }
`

export default ContentBlockWithImage
